import { render, staticRenderFns } from "./OrderDocModal.vue?vue&type=template&id=0d6a676c&scoped=true&"
import script from "./OrderDocModal.vue?vue&type=script&lang=js&"
export * from "./OrderDocModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderDocModal.vue?vue&type=style&index=0&id=0d6a676c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6a676c",
  null
  
)

export default component.exports